<template>
  <div class="business-card-visit-premium">
    <!-- Họa tiết máy cày cơ giới hóa chìm ở góc phải làm nền Watermark -->
    <div class="card-tractor-watermark">
      <svg viewBox="0 0 24 24" width="120" height="120" fill="none" stroke="currentColor" stroke-width="0.8">
        <circle cx="6" cy="18" r="3" />
        <circle cx="17" cy="16" r="5" />
        <path d="M9 18h3v-5H9v5zM12 13h4v-3h-4v3zM16 10h-2V7h2v3zM6 15v-4h3M12 18h2" />
      </svg>
    </div>

    <!-- Nội dung chính của Thẻ Bento -->
    <div class="card-content-layout">
      <!-- Cột Trái: Icon đại diện Hợp tác xã (Nền Mint nhạt + SVG Bắt tay đối tác) -->
      <div class="left-icon-box">
        <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="1.8"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M10 14H5.236a2 2 0 0 1-1.789-2.894l2-4A2 2 0 0 1 7.236 6H11a2 2 0 0 1 2 2v3" />
          <path d="M14 10h4.764a2 2 0 0 1 1.789 2.894l-2 4A2 2 0 0 1 16.764 18H13a2 2 0 0 1-2-2v-3" />
          <path d="m14 14-4-4" />
        </svg>
      </div>

      <!-- Cột Phải: Thông tin văn bản & Cụm nút hành động -->
      <div class="right-info-area">
        <div class="partner-badge">
          {{ $t('detail.cooperative_partner') || 'Hợp tác xã đối tác' }}
        </div>

        <h4 class="business-brand-name">
          {{ localizedName }}
        </h4>

        <div class="business-address-row" v-if="localizedDiaChi">
          <span class="isax isax-location icon-location-pin"></span>
          <span class="address-text">{{ localizedDiaChi }}</span>
        </div>

        <!-- Cụm nút bấm tương tác đôi -->
        <div class="actions-button-group">
          <!-- Nút Chi đường (Google Maps Link) -->
          <a :href="directionsUrl" target="_blank" class="btn-action-premium btn-directions">
            <span class="isax isax-routing icon-btn"></span>
            {{ $t('detail.directions') || 'Chi đường' }}
          </a>

          <!-- Nút Liên hệ (Tel Link) -->
          <a :href="'tel:' + (doanhNghiep.sdt || doanhNghiep.phone || '')" class="btn-action-premium btn-contact-phone"
            v-if="doanhNghiep.sdt || doanhNghiep.phone">
            <span class="isax isax-call icon-btn"></span>
            {{ $t('detail.contact') || 'Liên hệ' }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BusinessCardVisit',
  props: {
    doanhNghiep: {
      type: Object,
      required: true,
      default: () => ({
        name: '',
        nameEn: '',
        diaChi: '',
        diaChiEn: '',
        address: '',
        sdt: '',
        phone: '',
        link: '#'
      })
    }
  },
  computed: {
    // Giải quyết đa ngôn ngữ cho Tên gọi
    localizedName() {
      const currentLocale = this.$i18n ? this.$i18n.locale : "vi";
      if (currentLocale === "en") {
        return this.doanhNghiep.nameEn || this.doanhNghiep.name || "";
      }
      return this.doanhNghiep.name || "";
    },
    // Giải quyết đa ngôn ngữ cho Địa chỉ (Hỗ trợ cả trường diaChi và address)
    localizedDiaChi() {
      const currentLocale = this.$i18n ? this.$i18n.locale : "vi";
      const viAddress = this.doanhNghiep.diaChi || this.doanhNghiep.address || "";
      if (currentLocale === "en") {
        return this.doanhNghiep.diaChiEn || viAddress;
      }
      return viAddress;
    },

    // Tạo link chỉ đường thông minh
    directionsUrl() {
      // Nếu doanh nghiệp có sẵn link Google Maps hợp lệ, dùng link đó
      if (this.doanhNghiep.link && this.doanhNghiep.link !== "#" && this.doanhNghiep.link.startsWith("http")) {
        return this.doanhNghiep.link;
      }
      // Ngược lại, lấy Tên + Địa chỉ doanh nghiệp để tìm kiếm trực tiếp trên Google Maps
      const queryParts = [];
      if (this.localizedName) {
        queryParts.push(this.localizedName);
      }
      if (this.localizedDiaChi) {
        queryParts.push(this.localizedDiaChi);
      }
      const queryStr = queryParts.join(", ");
      if (queryStr) {
        return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(queryStr)}`;
      }
      return "#";
    }
  }
}
</script>

<style scoped>
/* ======================== PREMIUM BUSINESS BENTO CARD ======================== */
.business-card-visit-premium {
  position: relative;
  background-color: #ffffff;
  border: 1px solid rgba(187, 202, 186, 0.35);
  border-left: 6px solid var(--color-public-primary, #0d631b);
  /* Viền trái xanh lục thương hiệu */
  border-radius: 16px;
  padding: 24px;
  overflow: hidden;
  box-shadow: 0 10px 25px -5px rgba(13, 99, 27, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.02);
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.3s ease;
  min-height: 180px;
}

.business-card-visit-premium:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 30px -10px rgba(13, 99, 27, 0.12), 0 10px 15px -5px rgba(0, 0, 0, 0.04);
}

/* Watermark máy cày chìm */
.card-tractor-watermark {
  position: absolute;
  right: -10px;
  bottom: -15px;
  color: var(--color-public-primary, #0d631b);
  opacity: 0.05;
  pointer-events: none;
  z-index: 1;
}

.card-content-layout {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  height: 100%;
}

/* ======================== CỘT TRÁI: ICON BOX ======================== */
.left-icon-box {
  width: 64px;
  height: 64px;
  background-color: #e8f5e9;
  /* Nền xanh mint nhạt */
  color: var(--color-public-primary, #0d631b);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1px solid rgba(13, 99, 27, 0.1);
}

/* ======================== CỘT PHẢI: INFO AREA ======================== */
.right-info-area {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  min-width: 0;
  /* Khắc phục lỗi tràn flex-box */
}

/* Nhãn HTX ĐỐI TÁC */
.partner-badge {
  font-family: var(--font-body-standard), sans-serif;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  color: var(--color-public-primary, #0d631b);
  letter-spacing: 0.05em;
  margin-bottom: 4px;
  line-height: 1.2;
}

/* Tên thương hiệu Hợp tác xã */
.business-brand-name {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 1.3rem;
  font-weight: 850;
  color: #1a1a1a;
  margin: 0 0 8px 0;
  line-height: 1.3;
}

/* Hàng địa chỉ liên hệ */
.business-address-row {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-bottom: 20px;
}

.icon-location-pin {
  font-size: 18px;
  color: var(--color-public-primary, #0d631b);
  flex-shrink: 0;
  margin-top: 2px;
}

.address-text {
  font-family: var(--font-body-standard), sans-serif;
  font-size: 13px;
  color: var(--on-surface-variant, #40493d);
  line-height: 1.45;
}

/* ======================== CỤM NÚT PREMIUM ======================== */
.actions-button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
}

.btn-action-premium {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 20px;
  border-radius: 10px;
  font-family: var(--font-body-standard), sans-serif;
  font-weight: 700;
  font-size: 13px;
  text-decoration: none !important;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  height: 38px;
  box-sizing: border-box;
}

/* Nút Chi đường (Forest Green) */
.btn-directions {
  background-color: var(--color-public-primary, #0d631b);
  color: #ffffff !important;
  border: none;
}

.btn-directions:hover {
  background-color: #083d10;
  transform: translateY(-1px);
}

/* Nút Liên hệ (White & Border) */
.btn-contact-phone {
  background-color: #ffffff;
  color: var(--color-public-primary, #0d631b) !important;
  border: 1px solid var(--outline-variant, #bfcaba);
}

.btn-contact-phone:hover {
  background-color: rgba(13, 99, 27, 0.03);
  border-color: var(--color-public-primary, #0d631b);
  transform: translateY(-1px);
}

.icon-btn {
  font-size: 16px;
}

/* ======================== THÍCH ỨNG DI ĐỘNG (RESPONSIVE) ======================== */
@media (max-width: 576px) {
  .business-card-visit-premium {
    padding: 16px;
    min-height: auto;
  }

  .card-content-layout {
    gap: 12px;
  }

  .left-icon-box {
    width: 48px;
    height: 48px;
    border-radius: 12px;
  }

  .left-icon-box svg {
    width: 24px;
    height: 24px;
  }

  .business-brand-name {
    font-size: 1.1rem;
  }

  .address-text {
    font-size: 12px;
  }

  .actions-button-group {
    flex-direction: column;
    width: 100%;
    gap: 8px;
  }

  .btn-action-premium {
    width: 100%;
    padding: 6px 12px;
    font-size: 12px;
  }
}
</style>